/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/display-name */
import Divider from '@material-ui/core/Divider'
import Drawer from '@material-ui/core/Drawer'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import AccountBoxIcon from '@material-ui/icons/AccountBox'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import EditIcon from '@material-ui/icons/Edit'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import SettingsEthernetIcon from '@material-ui/icons/SettingsEthernet'
import { useKeycloak } from '@react-keycloak/web'
import { motion } from 'framer-motion'
import React from 'react'
import {
  Link,
  LinkProps as RouterLinkProps,
  useHistory,
  useLocation
} from 'react-router-dom'
import { useEditMode } from '../../../providers/EditMode'
import { useWorkspace } from '../../../providers/workspace'
import {
  animationAppTransitions,
  animationAppVariants
} from '../../Helpers/pageAnimation'
import { MenuOptionProps, MenuOptions } from '../ConfigMenu/options'

const drawerWidth = 240

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      height: '100vh'
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0
    },
    toolbar: {
      ...theme.mixins.toolbar,
      height: 100,
      background: 'linear-gradient(197.24deg, #246193 0%, #246193 98.81%)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textDecoration: 'none'
    },
    drawerPaper: {
      width: drawerWidth,
      background: '#FAFBFC',
      boxShadow: '5px 0px 10px rgba(36, 97, 147, 0.2)',
      height: '100vh'
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
      overflow: 'auto'
    },
    listItem: {
      color: '#4F4F4F',
      '&.Mui-selected': {
        color: theme.palette.primary.dark
      }
    }
  })
)

function ListItemLink(props: MenuOptionProps): JSX.Element {
  const { icon: Icon, title, path } = props
  const location = useLocation()
  const classes = useStyles()

  const RenderLink = React.useMemo(
    () =>
      React.forwardRef<any, Omit<RouterLinkProps, 'to'>>((itemProps, ref) => (
        <Link to={path} ref={ref} {...itemProps} />
      )),
    [path]
  )

  RenderLink.displayName = 'RenderLinkMemo'

  return (
    <li>
      <ListItem
        className={classes.listItem}
        button
        component={RenderLink}
        selected={
          path === '/configuracao'
            ? location.pathname === path
            : location.pathname.startsWith(path)
        }
      >
        {Icon ? <Icon style={{ marginRight: 10 }} /> : null}
        <ListItemText primary={title} />
      </ListItem>
    </li>
  )
}

export const ConfigLayout: React.FC = ({ children }) => {
  const classes = useStyles()
  const { keycloak } = useKeycloak()
  const { editMode, updateEditMode } = useEditMode()
  const { push, location } = useHistory()
  const {
    setSelectedWorkspace,
    setWorkspaceSelectorOpen,
    setRedirectTo
  } = useWorkspace()

  const handleChangeWorkspace = () => {
    setRedirectTo(location.pathname)
    setSelectedWorkspace(undefined)
    setWorkspaceSelectorOpen(true)
  }

  const drawer = (
    <div>
      <div className={classes.toolbar}>
        <Link to="/nav" style={{ color: '#fff' }}>
          <ArrowBackIosIcon />
        </Link>
      </div>

      <Divider />
      <List>
        <div>
          <ListItem
            className={classes.listItem}
            button
            onClick={() => keycloak.accountManagement()}
          >
            <AccountBoxIcon style={{ marginRight: 10 }} />
            <ListItemText primary="Perfil" />
          </ListItem>
        </div>
        {MenuOptions.map((menu, index) => (
          <div key={index}>
            <ListItemLink
              path={menu.path}
              title={menu.title}
              icon={menu.icon}
            />
          </div>
        ))}
        <li>
          <ListItem
            className={classes.listItem}
            button
            selected={editMode}
            onClick={() => {
              updateEditMode(!editMode)
              push('/nav/')
            }}
          >
            <EditIcon style={{ marginRight: 10 }} />
            <ListItemText
              primary={
                editMode ? 'Desativar modo de edição' : 'Ativar modo de edição'
              }
            />
          </ListItem>
        </li>
        <li>
          <ListItem
            className={classes.listItem}
            button
            onClick={() => keycloak.logout()}
          >
            <ExitToAppIcon style={{ marginRight: 10 }} />
            <ListItemText primary="Sair" />
          </ListItem>
        </li>
        <li>
          <ListItem
            className={classes.listItem}
            button
            onClick={handleChangeWorkspace}
          >
            <SettingsEthernetIcon style={{ marginRight: 10 }} />
            <ListItemText primary="Alterar Workspace" />
          </ListItem>
        </li>
      </List>
    </div>
  )

  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={animationAppVariants}
      transition={animationAppTransitions}
      className={classes.root}
    >
      <nav className={classes.drawer} aria-label="mailbox folders">
        <Drawer
          classes={{
            paper: classes.drawerPaper
          }}
          variant="permanent"
          open
        >
          {drawer}
        </Drawer>
      </nav>
      <main className={classes.content}>{children}</main>
    </motion.div>
  )
}
